export default function getValueOffPercent(value: number, price: number): number {
  return value > 0 && price > 0 ? Math.floor((value - price) * 100 / value) : 0
}
